import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { HomepageDataSource } from 'src/modules/homepage/services/homepage-data-source';
import { HomepageApiService } from 'src/modules/homepage/services/homepage-api-service';
import { HomepageAdd } from './modals/add/component';
import { AddFiles } from 'src/modules/directives/components/add-files/component';
@Component({
    selector: 'homepage-dashboard',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class HomepageOffersDashboard implements OnInit, OnDestroy {
  @Input() currentTab: BehaviorSubject<string>;
  private Subscriptions: Subscription[] = [];
  public DataSource = new HomepageDataSource(this.HomepageApi, 'admin');
  public homepageOffers;
  public loading: boolean;
  public imageUrl: string = '';
  public image;
  public homepageOfferPairs: { current: any; future: any }[] = [];
  public displayedColumns = ['company_name', 'offer', 'actions'];

  constructor(
    private HomepageApi: HomepageApiService,
    private dialog: MatDialog
  ) {}
  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );

    this.Subscriptions.push(
      this.DataSource.connect().subscribe((data) => {
        this.homepageOffers = data;
        this.groupOffers();
      })
    );

    this.Subscriptions.push(
      this.currentTab.subscribe(
        (tab) => 'homepage-admin' === tab && this.DataSource.load()
      )
    );
  }

  private groupOffers() {
    const titleMap = {
      'Main Carousels': 'Future Main Carousels',
      'Homepage Products': 'Future Homepage Products',
      'Default Main Carousels': 'Default Homepage Products',
    };

    this.homepageOfferPairs = [];

    for (const currentTitle in titleMap) {
      const current = this.homepageOffers.find((c) => c.title === currentTitle);
      const future = this.homepageOffers.find(
        (c) => c.title === titleMap[currentTitle]
      );

      if (current && future) {
        this.homepageOfferPairs.push({ current, future });
      }
    }
  }

  drop(event: CdkDragDrop<[]>, categoryId) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    const { data, id: type } = event.container;
    const OrderedInfos = data.map((row, order) => {
      const { id } = row;
      return {
        order,
        id,
        type,
      };
    });
    this.DataSource.setOrder(OrderedInfos, categoryId);
  }

  addCarouselItem(event, catId, catTitle) {
    event.stopPropagation();
    const DialogConfig = new MatDialogConfig();
    const data = {
      HomepageOffers: this.homepageOffers,
      HomepageDataSource: this.DataSource,
      CategoryId: catId,
      CategoryTitle: catTitle,
    };

    DialogConfig.disableClose = true;
    DialogConfig.data = data;

    this.Subscriptions.push(
      this.dialog
        .open(HomepageAdd, DialogConfig)
        .afterClosed()
        .subscribe((result) => {})
    );
  }

  public addImage(event, listing) {
    const config = new MatDialogConfig();
    config.data = {
      role: 'listing-admin',
      homepageProdId: listing.carousel_id,
      allowMultpleUpload: false,
      allowFiles: false,
    };
    config.disableClose = true;
    this.dialog
      .open(AddFiles, config)
      .afterClosed()
      .subscribe((files) => {
        this.image = files.files[0];
        this.DataSource.updateListingImage(listing.carousel_id, this.image);
      });
  }
  deleteListing(carouselId) {
    confirm('Are you sure you want to remove the listing from the carousel?') &&
      this.DataSource.delete(carouselId);
  }

  public removeImage(listing) {
    confirm('Are you sure you want to remove the image from the carousel?') &&
      this.DataSource.removeImage(listing.carousel_id);
  }

  ngOnDestroy() {
    this.DataSource.disconnect();
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
